import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["id", "value", "showUpload", "showSearch", "onSearch", "render", "className", "onChange", "width", "size", "disabled", "showTooltip", "tooltip", "onFocus", "onBlur", "placeholder", "onClear", "allowClear", "startIcon", "endIcon", "onUpload", "innerButton", "disableSearch", "disableUpload", "nonEditable", "readOnly", "right"],
    _excluded2 = ["empty"],
    _excluded3 = ["canElementTriggerFocus", "defaultValue", "Wrapper", "dropdown", "className", "contentProps", "onClear", "onUpdate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import { isFunction } from '@jd/jmtd-tools/es/is';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';
import Icon from '../Icon';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
import Dropdown from '../Dropdown/Dropdown';
import Tooltip from '../Tooltip';
import BasicInput from '../BasicInput';
import { getLocale } from '../locale';
import { getValue, isEventElementMatch } from '../tools/util';

var Input = /*#__PURE__*/function (_PureComponent) {
  _inherits(Input, _PureComponent);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);
    _this.cxt = {
      state: {}
    };
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onUpdate && this.onUpdate(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var cxt = this.cxt,
          focused = this.focused,
          _this$props = this.props,
          id = _this$props.id,
          value = _this$props.value,
          showUpload = _this$props.showUpload,
          showSearch = _this$props.showSearch,
          onSearch = _this$props.onSearch,
          _render2 = _this$props.render,
          className = _this$props.className,
          onChange = _this$props.onChange,
          width = _this$props.width,
          size = _this$props.size,
          disabled = _this$props.disabled,
          showTooltip = _this$props.showTooltip,
          tooltip = _this$props.tooltip,
          _onFocus = _this$props.onFocus,
          _onBlur = _this$props.onBlur,
          placeholder = _this$props.placeholder,
          _onClear = _this$props.onClear,
          allowClear = _this$props.allowClear,
          startIcon = _this$props.startIcon,
          endIcon = _this$props.endIcon,
          onUpload = _this$props.onUpload,
          innerButton = _this$props.innerButton,
          disableSearch = _this$props.disableSearch,
          disableUpload = _this$props.disableUpload,
          nonEditable = _this$props.nonEditable,
          _this$props$readOnly = _this$props.readOnly,
          readOnly = _this$props$readOnly === void 0 ? nonEditable : _this$props$readOnly,
          right = _this$props.right,
          otherProps = _objectWithoutProperties(_this$props, _excluded);

      if (value !== this.lastInputValue) {
        this.inputValue = '';
      }

      this.lastInputValue = value;
      return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
        size: size
      }, function (_ref) {
        var configSize = _ref.size,
            locale = _ref.locale;
        var realWidth = width !== null && width !== void 0 ? width : {
          large: 460,
          small: 340,
          mini: 340
        }[configSize] || 360;

        var change = function change() {
          var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cxt.value;

          if (isFunction(v)) {
            var _currentCxt$value;

            var currentCxt = _this2.cxt,
                currentValue = _this2.props.value;
            v = v((_currentCxt$value = currentCxt.value) !== null && _currentCxt$value !== void 0 ? _currentCxt$value : currentValue);
          }

          onChange(v);
        };

        var update = function update(result) {
          Object.assign(cxt, result);

          _this2.forceUpdate();
        };

        return /*#__PURE__*/React.createElement(Dropdown, {
          className: className,
          render: function render(_ref2) {
            var open = _ref2.open,
                setOpen = _ref2.setOpen,
                triggerNode = _ref2.triggerNode;
            var currentValue = 'value' in cxt ? cxt.value : value;

            var _render = _render2(_objectSpread({
              self: _this2,
              size: configSize,
              open: open,
              setOpen: setOpen,
              className: className,
              change: change,
              update: update,
              value: currentValue,
              ref: _this2.ref,
              readOnly: readOnly,
              setRef: function setRef(el) {
                _this2.ref = el;
              },
              triggerNode: triggerNode
            }, cxt), _objectSpread({
              width: realWidth,
              disabled: disabled,
              onFocus: function onFocus(e) {
                _this2.focused = true;

                _this2.forceUpdate();

                _onFocus(e);
              },
              onBlur: function onBlur(e) {
                _this2.focused = false;

                _this2.forceUpdate();

                _onBlur(e);
              },
              onInput: function onInput(v) {
                _this2.inputValue = v;

                _this2.forceUpdate();
              }
            }, otherProps)),
                _render$canElementTri = _render.canElementTriggerFocus,
                canElementTriggerFocus = _render$canElementTri === void 0 ? function () {
              return true;
            } : _render$canElementTri,
                defaultValue = _render.defaultValue,
                Wrapper = _render.Wrapper,
                dropdown = _render.dropdown,
                _render$className = _render.className,
                renderClassName = _render$className === void 0 ? '' : _render$className,
                _render$contentProps = _render.contentProps,
                empty = _render$contentProps.empty,
                contentProps = _objectWithoutProperties(_render$contentProps, _excluded2),
                _render$onClear = _render.onClear,
                onRenderClear = _render$onClear === void 0 ? function () {} : _render$onClear,
                onUpdate = _render.onUpdate,
                othersDropdownProps = _objectWithoutProperties(_render, _excluded3);

            _this2.onUpdate = onUpdate; // 上传按钮和确认按钮组

            var buttons = []; // 上传按钮

            if (showUpload) {
              buttons.push( /*#__PURE__*/React.createElement(Button, {
                className: "jmtd-input-button jmtd-input-upload-button",
                disabled: getValue(disableUpload, value, _this2.props) || disabled,
                key: "upload",
                file: true,
                onChange: onUpload,
                outline: true,
                endIcon: /*#__PURE__*/React.createElement(Icon, {
                  className: "jmti-upload"
                })
              }));
            } // 搜索按钮


            if (showSearch) {
              buttons.push( /*#__PURE__*/React.createElement(Button, {
                outline: true,
                className: "jmtd-input-button jmtd-input-search-button",
                key: "search",
                onClick: onSearch,
                disabled: getValue(disableSearch, value, _this2.props) || disabled,
                endIcon: /*#__PURE__*/React.createElement(Icon, {
                  className: "jmti-search"
                })
              }));
            } // 是否有上传或确认按钮，如果有，使用ButtonGroup进行包裹


            var hasButtons = buttons.length > 0; // 输入框主体

            var main = /*#__PURE__*/React.createElement(Wrapper, _extends({
              id: id,
              empty: !_this2.inputValue && empty,
              focused: focused,
              startIcon: startIcon,
              endIcon: endIcon,
              disabled: disabled,
              placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getLocale(locale).common.pleaseEnter,
              innerButton: innerButton,
              extraRight: right,
              className: classNames('jmtd-input', renderClassName, _defineProperty({}, className, !hasButtons)),
              width: realWidth,
              onClear: function onClear() {
                change(defaultValue);

                _onClear();

                onRenderClear();
              },
              onMouseDown: function onMouseDown(e) {
                if (readOnly) {
                  return;
                }

                if (e.target.tagName !== 'INPUT') {
                  e.preventDefault();
                } // 遍历元素，判断是否可以触发focus


                if (isEventElementMatch(e, function (el) {
                  return !el.classList.contains('jmtd-base-input-disabled-wall') && canElementTriggerFocus(el);
                })) {
                  _this2.ref.focus();
                }
              },
              allowClear: allowClear && !empty,
              readOnly: readOnly
            }, contentProps)); // 带输入提示，使用tooltip的受控模式

            if (showTooltip) {
              main = /*#__PURE__*/React.createElement(Tooltip, {
                placement: "topLeft",
                open: _this2.focused && !!cxt.value,
                trigger: "control",
                title: tooltip || otherProps.placeholder
              }, main);
            }

            return _objectSpread({
              children: !buttons.length ? main : /*#__PURE__*/React.createElement(ButtonGroup, {
                className: classNames('jmtd-input-group', _defineProperty({}, className, hasButtons))
              }, main, buttons),
              dropdown: dropdown,
              exclusive: true
            }, othersDropdownProps);
          }
        });
      });
    }
  }]);

  return Input;
}(PureComponent);

export { Input as default };
Input.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
  showSearch: PropTypes.bool,
  render: PropTypes.func,
  className: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.node,
  showTooltip: PropTypes.bool,
  tooltip: PropTypes.node,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  showUpload: PropTypes.bool,
  onUpload: PropTypes.func,
  disabled: PropTypes.bool,
  onClear: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onSearch: PropTypes.func,
  allowClear: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  innerButton: PropTypes.node,
  disableSearch: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  disableUpload: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  readOnly: PropTypes.bool,
  nonEditable: PropTypes.bool,
  right: PropTypes.node
};
Input.defaultProps = {
  id: null,
  value: undefined,
  showSearch: false,
  render: BasicInput,
  className: '',
  onChange: function onChange() {},
  onSearch: function onSearch() {},
  onClear: function onClear() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  showTooltip: false,
  tooltip: undefined,
  width: null,
  placeholder: null,
  size: null,
  showUpload: false,
  onUpload: function onUpload() {},
  disabled: false,
  allowClear: true,
  startIcon: null,
  endIcon: null,
  innerButton: null,
  disableSearch: false,
  disableUpload: false,
  readOnly: undefined,
  nonEditable: false,
  right: undefined
};